import React, { useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { API_URL } from "..";

const LedgerPage = () => {
  const today = new Date().toISOString().slice(0, 10);

  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [ledger, setLedger] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch Ledger
  const loadLedger = async () => {
    setLoading(true);
    try {
      const res = await fetch(
        `${API_URL}/api/accounts/ledger?startDate=${fromDate}&endDate=${toDate}`
      );
      const data = await res.json();

      if (res.ok) setLedger(data.ledger || []);
      else alert(data.message || "Failed to load ledger");

    } catch (err) {
      console.error(err);
      alert("Something went wrong");
    }
    setLoading(false);
  };

  useEffect(() => {
    loadLedger();
  }, []);

  const formatDate = (d) =>
    new Date(d).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

  // Running balance calculation
  const ledgerWithBalance = (() => {
    let balance = 0;
    return ledger.map((entry) => {
      const debit = entry.direction === "OUT" ? Number(entry.amount) : 0;
      const credit = entry.direction === "IN" ? Number(entry.amount) : 0;
      balance = balance + credit - debit;

      return { ...entry, debit, credit, balance };
    });
  })();

  // Summary
  const totalDebit = ledgerWithBalance.reduce((s, r) => s + r.debit, 0);
  const totalCredit = ledgerWithBalance.reduce((s, r) => s + r.credit, 0);
  const closingBalance = totalCredit - totalDebit;

  return (
    <MasterLayout>
      <Breadcrumb title="General Ledger" />

      <div className="card p-4">

        {/* ----------------- Filters ----------------- */}
        <div className="row mb-4">
          <div className="col-md-3">
            <label className="form-label fw-bold">From Date</label>
            <input
              type="date"
              className="form-control"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>

          <div className="col-md-3">
            <label className="form-label fw-bold">To Date</label>
            <input
              type="date"
              className="form-control"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>

          <div className="col-md-3 d-flex align-items-end">
            <button className="btn btn-primary w-100" onClick={loadLedger}>
              Apply Filter
            </button>
          </div>
        </div>

        {/* ----------------- Ledger Summary ----------------- */}
        <div className="row mb-4">
          <div className="col-md-4">
            <div className="p-3 border rounded bg-light">
              <h6 className="text-muted mb-1">Total Debit</h6>
              <h4 className="text-danger mb-0">Rs. {totalDebit.toLocaleString()}</h4>
            </div>
          </div>

          <div className="col-md-4">
            <div className="p-3 border rounded bg-light">
              <h6 className="text-muted mb-1">Total Credit</h6>
              <h4 className="text-success mb-0">Rs. {totalCredit.toLocaleString()}</h4>
            </div>
          </div>

          <div className="col-md-4">
            <div className="p-3 border rounded bg-light">
              <h6 className="text-muted mb-1">Closing Balance</h6>
              <h4 className="mb-0">
                {closingBalance >= 0 ? (
                  <span className="text-success">Rs. {closingBalance.toLocaleString()}</span>
                ) : (
                  <span className="text-danger">Rs. {closingBalance.toLocaleString()}</span>
                )}
              </h4>
            </div>
          </div>
        </div>

        {/* ----------------- Ledger Table ----------------- */}
        <div className="table-responsive">
          <table className="table table-bordered table-hover">
            <thead className="bg-dark text-white">
              <tr>
                <th>Date</th>
                <th>Description</th>
                <th>Reference</th>
                <th className="text-end text-danger">Debit (DR)</th>
                <th className="text-end text-success">Credit (CR)</th>
                <th className="text-end">Running Balance</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="text-center py-4">
                    <div className="spinner-border text-primary"></div>
                  </td>
                </tr>
              ) : ledgerWithBalance.length === 0 ? (
                <tr>
                  <td colSpan="6" className="text-center py-4">
                    No transactions found
                  </td>
                </tr>
              ) : (
                ledgerWithBalance.map((row, idx) => (
                  <tr
                    key={idx}
                    className={idx % 2 === 0 ? "table-light" : ""}
                  >
                    <td>{formatDate(row.date)}</td>
                    <td className="fw-semibold">{row.title}</td>
                    <td>{row.reference || "—"}</td>

                    <td className="text-end text-danger">
                      {row.debit ? `Rs. ${row.debit.toLocaleString()}` : "—"}
                    </td>

                    <td className="text-end text-success">
                      {row.credit ? `Rs. ${row.credit.toLocaleString()}` : "—"}
                    </td>

                    <td className="text-end fw-bold">
                      {row.balance >= 0 ? (
                        <span className="text-success">
                          Rs. {row.balance.toLocaleString()}
                        </span>
                      ) : (
                        <span className="text-danger">
                          Rs. {row.balance.toLocaleString()}
                        </span>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

      </div>
    </MasterLayout>
  );
};

export default LedgerPage;
